import users from './data'

export default {
    signin: ({ data }) => {
        const { email } = JSON.parse(data || '')
        const response = users.find(user => user.email === email)

        if (!response) return [404]
        return [200, { data: response }]
    },
}
